import useSWR from "swr"
import { DeliveryRouteApi } from "../../../apis"

export function useRouteQuery(id: string | null | undefined) {
  return useSWR(
    id ? ["delivery-route", id] : null,
    async () => DeliveryRouteApi.get(id as string),
    { revalidateOnFocus: false },
  )
}
